import { ThemeOptions, darken } from "@mui/material/styles";

import { getInvertColor } from "utils/themeUtils";

export const radioOverrides: ThemeOptions["components"] = {
	MuiRadio: {
		styleOverrides: {
			root: ({ ownerState: { color }, theme }) => {
				const mainColor = theme.palette[`${color}`]?.main || theme.palette.primary.main;
				const isLight = getInvertColor(mainColor) === theme.palette.dirtyWhite["2000"];
				const isPrimaryOrSecondary = ["primary", "secondary"].includes(`${color}`);

				return {
					color: theme.palette.dirtyWhite["1000"],

					"&.Mui-checked": {
						color:
							isPrimaryOrSecondary && isLight
								? darken(theme.palette.primary.main, 0.5)
								: theme.palette.primary.main, // checked color
					},
				};
			},
		},
	},
};
